import {
  get,
  post,
} from 'helpers/RequestUtil'
import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeLatest,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'
import T from 'i18n-react'
import * as R from 'ramda'
import P from 'helpers/predicates'

import {
  INIT_REVISIONS,
  POST_PROJECT_REVISION,
  FETCH_PROJECT_REVISIONS,
  FETCH_REVISION_DATA,
  LOAD_REVISION_DATA,
} from './constants'

import {
  LOAD_REVISION_SUCCESS,
  LOAD_REVISION_ERROR
} from 'containers/Form/constants'

import {
  loadRevisionDataSuccess,
  startPostProjectRevision,
  postProjectRevisionStart,
  postProjectRevisionSuccess,
  postProjectRevisionError,
  fetchProjectRevisions as fetchProjectRevisionsAction,
  fetchProjectRevisionsStart,
  fetchProjectRevisionsSuccess,
  fetchProjectRevisionsError,
  startFetchProjectRevisions,
  fetchRevisionData as fetchRevisionDataAction,
  fetchRevisionDataStart,
  fetchRevisionDataSuccess,
  fetchRevisionDataError,
  startFetchRevisionData,
  updateRevisions,
} from './actions'

import {
  updateTablesAction,
  removeTables,
  clearTables,
} from 'containers/Entity/actions'

import {
  loadRevision,
} from 'containers/Form/actions'

import {
  error,
  success
} from 'containers/App/Notification/actions'

import {
  loadedRevisions as loadedRevisionsSelector,
} from './selectors'

function* fetchProjectRevisions(projectId) {
  try {
    yield put(startFetchProjectRevisions())
    yield put(fetchProjectRevisionsStart())
    const data = yield call(
      get,
      `/api/fulcrum/projects/${projectId}/project_revisions?sort=-revision_id`
    )
    const {
      result: { project_revisions }
    } = data
    yield put(updateTablesAction(data))
    yield put(fetchProjectRevisionsSuccess())
    return project_revisions
  } catch(error) {
    yield put(fetchProjectRevisionsError(error))
  }
}

function* fetchRevisionData(projectId, revisionIds) {
  try {
    yield put(startFetchRevisionData())
    yield put(fetchRevisionDataStart())
    const filterIds = revisionIds.join(',')
    const data = yield call(
      get,
      `/api/fulcrum/projects/${projectId}/revisions?filter[id]=${filterIds}`
    )
    const {
      result: { revisions }
    } = data
    yield put(updateTablesAction(data))
    yield put(fetchRevisionDataSuccess())
    return revisions
  } catch(error) {
    yield put(fetchRevisionDataError(error))
  }
}


function* postProjectRevision(id, params) {
  try {
    yield put(startPostProjectRevision())
    yield put(postProjectRevisionStart()) 
    yield call(
      post,
      'project_revisions',
      params,
      '/api/fulcrum/project/revisions'
    )
    yield put(postProjectRevisionSuccess())
    yield put(success(T.translate('pages.project.overview.notification.post_saved', {id})))
  } catch(error) {
    yield put(postProjectRevisionError(error))
  }
}

function* handleLoadRevision({ projectId, revisionId }) {
  let elements
  const loadedRevisions = yield select(loadedRevisionsSelector)

  if (R.complement(R.contains)(revisionId.toString(), loadedRevisions))
    yield call(fetchRevisionData, projectId, [revisionId])

  yield put(loadRevision(revisionId))
  const action = yield take([LOAD_REVISION_SUCCESS, LOAD_REVISION_ERROR])
  if (action.type === LOAD_REVISION_SUCCESS) {
    elements = action.elements
    yield put(updateRevisions(revisionId, elements))
  }
  yield put(loadRevisionDataSuccess(elements))
}

function* handleFetchProjectRevisions({ projectId }) {
  const projectRevisions = yield call(fetchProjectRevisions, projectId)
  return projectRevisions
}

function* handleFetchRevisionData({ projectId, revisionsId }) {
  const revisions = yield call(fetchRevisionData, projectId)
  return revisions
}

function* handlePostProjectRevision({ projectId, params }) {
  yield call(postProjectRevision, projectId, params)
}

function* handleInitialize() {
  yield put(removeTables('revisions'))
  yield put(removeTables('project_revisions'))
}

function* watchFetchProjectRevisions() {
  yield takeEvery(FETCH_PROJECT_REVISIONS, handleFetchProjectRevisions)
}

function* watchFetchRevisionData() {
  yield takeEvery(FETCH_REVISION_DATA, handleFetchRevisionData)
}

function* watchLoadRevisionData() {
  yield takeEvery(LOAD_REVISION_DATA, handleLoadRevision)
}

function* watchPostProjectRevision() {
  yield takeEvery(POST_PROJECT_REVISION, handlePostProjectRevision)
}

function* watchInitRevisions() {
  yield takeEvery(INIT_REVISIONS, handleInitialize)
}

function* loadSagas() {
  yield all([
    fork(watchFetchProjectRevisions),
    fork(watchFetchRevisionData),
    fork(watchLoadRevisionData),
    fork(watchPostProjectRevision),
    fork(watchInitRevisions)
  ])
}

export {
  fetchProjectRevisions
}
export default loadSagas
